import axiosInstance from "../../api/axiosInstance";

export const markPrizeAsDeliveredAPI = async (payload) => {
  const response = await axiosInstance.post(
    "prizeDelivery/mark-prize-as-deliverd",
    payload
  );
  return response.data;
};

export const unmarkPrizeAsDeliveredAPI = async (payload) => {
  const response = await axiosInstance.delete(
    "prizeDelivery/mark-prize-as-not-deliverd",
    {
      data: payload,
    }
  );
  return response.data;
};

export const fetchTournamentsWithPrizeStatusAPI = async (
  page = 1,
  limit = 10
) => {
  const response = await axiosInstance.get(
    `prizeDelivery/with-status?page=${page}&limit=${limit}`
  );
  return response.data;
};

// Ended tournaments this player won and hasn't received the prize for.
export const fetchPendingPrizesAPI = async (userId) => {
  const response = await axiosInstance.get(`prizeDelivery/pending/${userId}`);
  return Array.isArray(response.data?.data) ? response.data.data : [];
};
